import * as React from 'react';
const Crop = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-crop", ...props },
    React.createElement("path", { d: "M6.13 1L6 16a2 2 0 0 0 2 2h15" }),
    React.createElement("path", { d: "M1 6.13L16 6a2 2 0 0 1 2 2v15" })));
export default Crop;
//# sourceMappingURL=Crop.js.map